import type { AllOwnedSafes } from '@safe-global/safe-gateway-typescript-sdk'
import type { AsyncResult } from '@/hooks/useAsync'
import { useOwnersGetAllSafesByOwnerV2Query } from '@safe-global/store/gateway/AUTO_GENERATED/owners'
import { asError } from '@/services/exceptions/utils'

const useAllOwnedSafes = (address: string): AsyncResult<AllOwnedSafes> => {
  const { data, error, isLoading } = useOwnersGetAllSafesByOwnerV2Query(
    { ownerAddress: address },
    { skip: address === '' },
  )

  return [address ? data : undefined, asError(error), isLoading]
}

export default useAllOwnedSafes
